import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Icon = styled.img``

export const Title = styled.div`
  ${Typography.Body};
  ${FontWeights.Regular};
  margin: 0px 8px;
  white-space: nowrap;
`

export const Expert = styled.div`
  ${Typography.Tiny};
  ${FontWeights.DemiBold}
  border-radius: 4px;
  color: ${Colors.Blue50};
  padding: 4px 6px;
  background: ${Colors.Blue10};

  ${Media.Phone`
    margin-left: 30px;
  `};
`

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
`

export const Wrapper = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  cursor: pointer;

  &:hover {
    color: ${props => (props.disabled ? Colors.Neutral50 : Colors.Blue50)};
  }

  ${Expert} {
    color: ${props => (props.disabled ? Colors.Neutral50 : Colors.Blue50)};
    background: ${props => (props.disabled ? Colors.Neutral10 : Colors.Blue10)};
  }

  ${Title} {
    color: ${props => props.disabled && Colors.Neutral50};
  }

  ${Media.Phone`
    flex-direction: column;
    align-items: flex-start;
  `};
`
